import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useState } from "react";
import { getTrans as T } from "../../../Shared/Language";
import { Link } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { addTicket, getTicketListData } from "./TicketService";
import { TostMsg } from "../../../App";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import debounce from "lodash.debounce";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

function MyTickets() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [myTicketList, setMyTicketList] = useState([]);
  const [searchDataShow, setSearchDataShow] = useState(false);
  const [ticketMasterDataList, setTicketMasterDataList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({});
  const [selectedStatusValueChanged, setSelectedStatusValueChanged] =
    useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const observer = useRef();
  const [userUpdatePermission, setUserUpdatePermission] = useState(false);
  let searchValue = "";
  const [noData, setNoData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  useEffect(() => {
    GetMasterSystemAlertList("Ticket_Raised", 2);
    getMyTicketDetails(pageNumber);
    getTicketMasterData();
    permissionAccouncementList();
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Ticket.Add") {
        setUserUpdatePermission(true);
      }
    });
  };

  //Get My Ticket Details List
  async function getMyTicketDetails(page) {
    setIsLoading(true);
    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      RaisedByEmpId: userDetails?.EmpId.toString(), //0,
      AssignedToId: "", //userDetails?.EmpId,
      TicketId: 0,
      RequestStatusId: "",
      RequestCategoryId: "",
      RequestSubCategoryId: "",
      PriorityId: "",
      SeverityId: "",
      Search: searchValue,
      filterStartDate: "",
      filterEndDate: "",
      PageNumber: page,
      PageSize: 20,
    };
    try {
      const response = await getTicketListData(params);
      var newTickets = response?.Data?.OrgEmpRequests.reduce((unique, o) => {
        if (!unique.some((obj) => obj.Id === o.Id)) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (searchValue) {
        setMyTicketList(newTickets);
        if (newTickets.length == 0) {
          setSearchDataShow(true);
        }
      } else {
        setMyTicketList((prevTickets) => {
          const combinedMap = new Map();
          [...prevTickets, ...newTickets].forEach((ticket) => {
            combinedMap.set(ticket.Id, ticket);
          });
          return Array.from(combinedMap.values());
        });
      }
      setHasMore(newTickets.length > 0);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const getTicketMasterData = async () => {
    let params = {
      masterType: "TicketStatusType",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let responce = await GetMasterTypeData(params);
      setTicketMasterDataList(responce?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  };

  async function updateTicketStatus(selectStatusDone) {
    if (selectStatusDone) {
      setIsloading(true);
      const selectedStatus = selectStatusDone;
      const [key, value] = Object.entries(selectedStatus)[0];
      let updateTicketData = myTicketList?.filter(
        (item) => item.Id === Number(key)
      );
      const params = {
        Id: Number(key),
        IsDeleted: 0,
        RequestNumber: updateTicketData[0]?.RequestNumber,
        OrgId: userDetails?.OrgId,
        EmpId: updateTicketData[0]?.EmpId,
        RequestTitle: updateTicketData[0]?.RequestTitle,
        RequestDescription: updateTicketData[0]?.RequestDescription,
        RequestCategoryId: updateTicketData[0]?.RequestCategoryId,
        RequestSubCategoryId: updateTicketData[0]?.RequestSubCategoryId,
        Comment: updateTicketData[0]?.Comment,
        Severity: updateTicketData[0]?.Severity,
        Priority: updateTicketData[0]?.Priority,
        AssignedToId: updateTicketData[0]?.AssignedToId,
        RequestStatusId: value,
      };
      try {
        const statusUpdate = await addTicket(params);
        if (statusUpdate) {
          GetMasterSystemAlertList("Ticket_Updated", 0);
          setSelectedStatus({});
          setSelectedStatusValueChanged(true);
          getMyTicketDetails(1);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.TicketUpdate);
      } finally {
        setIsloading(false);
      }
    }
  }

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    handleSearch(event.target.value);
  };

  const handleSearch = useCallback(
    debounce((value) => {
      searchValue = value;
      getMyTicketDetails(pageNumber);
    }, 300),
    []
  );

  const findStatusId = (statusName) => {
    const matchedStatus = ticketMasterDataList?.find(
      (status) => status.Name.toLowerCase() === statusName.toLowerCase()
    );
    return matchedStatus ? matchedStatus.id : null;
  };

  const handleStatusChange = (newStatusValue, ticketId) => {
    setSelectedStatus((prevSelectedStatus) => ({
      ...prevSelectedStatus,
      [ticketId]: newStatusValue,
    }));

    const matchedStatus = ticketMasterDataList.find(
      (status) => status.Id === newStatusValue
    );

    setMyTicketList((prevTickets) =>
      prevTickets.map((ticket) =>
        ticket.Id === ticketId
          ? { ...ticket, RequestStatus: matchedStatus?.name }
          : ticket
      )
    );
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  useEffect(() => {
    if (Object.keys(selectedStatus)?.length > 0) {
      updateTicketStatus(selectedStatus);
    }
  }, [myTicketList, ticketMasterDataList, selectedStatus]);

  useEffect(() => {
    getMyTicketDetails(pageNumber);
  }, [pageNumber]);

  const lastTicketElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>

      <div className="container-fluid position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex mb-4">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">{T("My Tickets")}</h2>
              </div>
              <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
                <button className="input-group-text">
                  <i className="fa fa-search text-primary"></i>
                </button>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Search..."
                />
              </div>
              {userUpdatePermission && (
                <Link
                  to="/AddTicket"
                  className="button h-button is-primary is-raised is-bold addd-ticket"
                >
                  <span>New Ticket</span>
                </Link>
              )}
            </div>
          </div>
          <div className="col-xl-12">
            <div className="business-dashboard course-dashboard">
              <div className="course-grid">
                <div className="columns is-multiline">
                  {myTicketList?.map((myTickets, index) => {
                    if (index === myTicketList.length - 1) {
                      return (
                        <div
                          ref={lastTicketElementRef}
                          className="column is-4"
                          key={myTickets.Id}
                        >
                          <div className="course-card">
                            <div class="input-group mb-3">
                              <span className="tag is-green is-elevated">
                                {myTickets?.RequestStatus}
                              </span>
                              <Dropdown
                                className="w-fullticket-custom-dropdown"
                                value={selectedStatus[myTickets?.Id] || ""}
                                onChange={(e) => {
                                  handleStatusChange(e.value, myTickets?.Id) ||
                                    findStatusId(myTickets.RequestStatus);
                                }}
                                options={ticketMasterDataList}
                                optionLabel="Name"
                                optionValue="Id"
                                checkmark={true}
                                highlightOnSelect={false}
                              />
                            </div>

                            <h3 className="dark-inverted">
                              {myTickets?.RequestTitle?.length >= 25
                                ? `${myTickets?.RequestTitle.substring(
                                    0,
                                    25
                                  )}...`
                                : myTickets?.RequestTitle}
                            </h3>
                            <p>
                              {myTickets?.RequestDescription?.length >= 25
                                ? `${myTickets?.RequestDescription.substring(
                                    0,
                                    32
                                  )}...`
                                : myTickets?.RequestDescription}
                            </p>

                            <div className="students">
                              {myTickets?.ObserverLists.slice(0, 2).map(
                                (observer) => (
                                  <div className="h-avatar is-small">
                                    <img
                                      className="avatar"
                                      src={
                                        observer?.ProfileImage || defaultImage
                                      }
                                      alt={observer?.ObserverName}
                                      title={observer?.ObserverName}
                                      onError={handleImageError}
                                    />
                                  </div>
                                )
                              )}
                              {myTickets?.ObserverLists?.length >= 2 && (
                                <div className="h-avatar is-small">
                                  <span className="avatar is-fake is-dark-bg-2">
                                    <span>
                                      {myTickets?.ObserverLists?.length}
                                    </span>
                                  </span>
                                </div>
                              )}
                              <a className="link is-dark-primary">Observers</a>
                            </div>

                            <div className="attached-block">
                              <a className="is-dark-primary">Created On</a>
                              <div className="block-stats">
                                <span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-calendar"
                                  >
                                    <rect
                                      x="3"
                                      y="4"
                                      width="18"
                                      height="18"
                                      rx="2"
                                      ry="2"
                                    ></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                  </svg>
                                  {/* <small>Due {formattedDate}</small> */}
                                  <small>
                                    {moment(myTickets?.CreatedDate).format(
                                      "MMM DD YYYY"
                                    )}
                                  </small>
                                </span>
                              </div>
                            </div>
                            <div className="action-block">
                              <Link
                                to={`/Ticket/Detail/${myTickets?.RequestNumber}`}
                              >
                                <button
                                  className="button h-button is-primary is-raised is-fullwidth"
                                  fdprocessedid="79sscj"
                                >
                                  View Ticket
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="column is-4" key={myTickets?.Id}>
                          <div className="course-card">
                            <div class="input-group mb-3">
                              <span className="tag is-green is-elevated">
                                {myTickets?.RequestStatus}
                              </span>
                              <Dropdown
                                className="w-fullticket-custom-dropdown"
                                value={selectedStatus[myTickets?.Id] || ""}
                                onChange={(e) => {
                                  handleStatusChange(e.value, myTickets?.Id) ||
                                    findStatusId(myTickets.RequestStatus);
                                }}
                                options={ticketMasterDataList}
                                optionLabel="Name"
                                optionValue="Id"
                                checkmark={true}
                                highlightOnSelect={false}
                              />
                            </div>
                            <h3 className="dark-inverted">
                              {myTickets?.RequestTitle?.slice(0, 23)}.
                            </h3>
                            <p>
                              {myTickets?.RequestDescription?.slice(0, 32)}.
                            </p>
                            <div className="students">
                              {myTickets?.ObserverLists?.length > 0 ? (
                                <>
                                  {myTickets.ObserverLists.slice(0, 3).map(
                                    (observer) => (
                                      <div
                                        key={observer.ObserverName}
                                        className="h-avatar is-small"
                                      >
                                        <img
                                          className="avatar"
                                          src={
                                            observer.ProfileImage ||
                                            defaultImage
                                          }
                                          alt={observer.ObserverName}
                                          title={observer.ObserverName}
                                          onError={handleImageError}
                                        />
                                      </div>
                                    )
                                  )}

                                  {myTickets.ObserverLists.length > 3 && (
                                    <div className="h-avatar is-small">
                                      <span className="avatar is-fake is-dark-bg-2">
                                        <span>
                                          +{myTickets.ObserverLists.length - 3}
                                        </span>
                                      </span>
                                    </div>
                                  )}

                                  <a className="link is-dark-primary">
                                    Observers
                                  </a>
                                </>
                              ) : (
                                <span
                                  className="no-observers"
                                  style={{ height: "31px" }}
                                >
                                  No observers{" "}
                                </span>
                              )}
                            </div>

                            <div className="attached-block">
                              <a className="is-dark-primary">Created On</a>
                              <div className="block-stats">
                                <span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-calendar"
                                  >
                                    <rect
                                      x="3"
                                      y="4"
                                      width="18"
                                      height="18"
                                      rx="2"
                                      ry="2"
                                    ></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                  </svg>
                                  <small>
                                    {moment(myTickets?.CreatedDate).format(
                                      "MMM DD YYYY"
                                    )}
                                  </small>
                                </span>
                              </div>
                            </div>
                            <div className="action-block">
                              <Link
                                to={`/Ticket/Detail/${myTickets.RequestNumber}`}
                              >
                                <button
                                  className="button h-button is-primary is-raised is-fullwidth"
                                  fdprocessedid="79sscj"
                                >
                                  View Ticket
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
          {isLoading && <div>Loading more tickets...</div>}

          {myTicketList.length == 0 && !searchDataShow && (
            <div className="notfound">
              <img src="/images/no-data-found/tickets-not-found.png" />
              <p>{noData}</p>
            </div>
          )}
          {searchDataShow && (
            <div className="notfound">
              <img src="/images/no-data-found/tickets-not-found.png" />
              <p>No tickets found matching your search.</p>
            </div>
          )}
          {Isloading ? (
            <Suspense>
              <ComponentLoader />
            </Suspense>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default MyTickets;
